import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/HubspotCompanyName.graphql';
import { Query, QueryhubspotCompanyNameArgs } from '../../__generated__/globalTypes';

export const useHubspotCompanyNameQuery = (options?: QueryHookOptions<Query, QueryhubspotCompanyNameArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryhubspotCompanyNameArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useHubspotCompanyNameLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryhubspotCompanyNameArgs>
): QueryResult<Query, QueryhubspotCompanyNameArgs> & {
  getHubspotCompanyName: LazyQueryExecFunction<Query, QueryhubspotCompanyNameArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getHubspotCompanyName, result] = useLazyQuery<Query, QueryhubspotCompanyNameArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getHubspotCompanyName, ...result };
};

export const useHubspotCompanyNamePromiseQuery = () => {
  const client = useApolloClient();

  const getHubspotCompanyName = useCallback(
    (options?: Omit<QueryOptions<QueryhubspotCompanyNameArgs, Query>, 'query'>) =>
      client.query<Query, QueryhubspotCompanyNameArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getHubspotCompanyName };
};
// Suspense Query Hooks
export const useHubspotCompanyNameSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryhubspotCompanyNameArgs>
) => {
  const result = useSuspenseQuery<Query, QueryhubspotCompanyNameArgs>(QUERY, {
    ...options
  });

  return result;
};
